import _isEmpty from 'lodash/isEmpty';

export function getPageContentNodeComponents(page = {}) {
  const { components } = page;
  if (_isEmpty(components)) return [];

  return components.filter(({ contentNodes }) => !_isEmpty(contentNodes));
}
